// import { useState, useEffect } from 'react';
// import { 
//   Droplet, Shield, Check, ArrowRight, Star, 
//   CheckCircle, HelpCircle, Filter, Activity, 
//   RefreshCw, LifeBuoy, ThumbsUp, ChevronDown, ChevronRight 
// } from 'lucide-react';
// import NavBar from '../components/Navbar';
// import Footer from '../components/Footer';

// export default function WholeHomeWaterFiltration() {
//   const [activeTab, setActiveTab] = useState('features');
//   const [isVisible, setIsVisible] = useState({
//     hero: false,
//     benefits: false,
//     features: false,
//     process: false,
//     comparison: false,
//     faq: false,
//     testimonials: false,
//     cta: false
//   });
  
//   const [activeFaq, setActiveFaq] = useState(null);
//   const [activeTestimonial, setActiveTestimonial] = useState(0);
  
//   // Intersection Observer for animations
//   useEffect(() => {
//     const observerOptions = {
//       threshold: 0.2,
//       rootMargin: '0px 0px -100px 0px'
//     };
    
//     const observerCallback = (entries) => {
//       entries.forEach(entry => {
//         if (entry.isIntersecting) {
//           setIsVisible(prev => ({ ...prev, [entry.target.id]: true }));
//         }
//       });
//     };
    
//     const observer = new IntersectionObserver(observerCallback, observerOptions);
    
//     const sections = ['hero', 'benefits', 'features', 'process', 'comparison', 'faq', 'testimonials', 'cta'];
//     sections.forEach(section => {
//       const element = document.getElementById(section);
//       if (element) observer.observe(element);
//     });
    
//     return () => {
//       sections.forEach(section => {
//         const element = document.getElementById(section);
//         if (element) observer.unobserve(element);
//       });
//     };
//   }, []);
  
//   // Animation classes
//   const getAnimationClass = (section) => {
//     return isVisible[section] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10';
//   };
  
//   // FAQ data
//   const faqItems = [
//     {
//       question: "How long does a whole home water filtration system last?",
//       answer: "Our PureFlow systems are built to last 15-20 years with proper maintenance. The main filtration tank typically lasts the full system lifetime, while filter media should be replaced every 5-7 years depending on your water conditions and usage."
//     },
//     {
//       question: "Does the system require professional installation?",
//       answer: "While professional installation is recommended to ensure optimal performance and warranty coverage, our systems are designed for straightforward installation. Our certified technicians can complete most installations in 2-3 hours with minimal disruption to your home."
//     },
//     {
//       question: "Will a whole home system affect my water pressure?",
//       answer: "Our systems are engineered to maintain your home's water pressure. The PureFlow Max series features a high-flow design that ensures minimal pressure drop (typically less than 5 PSI), even during peak water usage times."
//     },
//     {
//       question: "How much maintenance is required?",
//       answer: "PureFlow systems are designed for minimal maintenance. They include automatic self-cleaning cycles, and most homeowners only need professional servicing once every 1-2 years. We provide maintenance reminders and offer service plans for worry-free ownership."
//     },
//     {
//       question: "Can this system remove well water contaminants?",
//       answer: "Yes, our whole home systems are highly effective for well water. We offer specialized configurations designed specifically for common well water issues like iron, sulfur, manganese, and acidic water. We recommend water testing first to customize the perfect solution for your specific water conditions."
//     }
//   ];
  
//   // Testimonials data
//   const testimonials = [
//     {
//       text: "The difference in our water quality is remarkable. No more dry skin, spotty dishes, or mineral buildup on our fixtures. The PureFlow whole home system has transformed our water and was worth every penny.",
//       author: "Michael & Sarah Johnson",
//       location: "Homeowners since 2023",
//       rating: 5
//     },
//     {
//       text: "As someone with sensitive skin and allergies, I've noticed a huge improvement since installing the PureFlow system. The shower water feels softer, and I no longer have the itchy feeling after bathing. Our clothes are also softer and brighter after washing.",
//       author: "Jennifer Torres",
//       location: "Homeowner since 2022",
//       rating: 5
//     },
//     {
//       text: "Installation was quick and professional, and the results were immediate. The system is completely silent, takes up minimal space, and has required zero maintenance in the year we've had it. Our water tastes better than any bottled water we've tried.",
//       author: "Robert Chen",
//       location: "Homeowner since 2024",
//       rating: 5
//     }
//   ];
  
//   // Features tabs
//   const featureTabs = [
//     {
//       id: 'features',
//       label: 'Key Features',
//       content: [
//         { 
//           title: "Multi-Stage Filtration", 
//           description: "Our 5-stage filtration process removes sediment, chlorine, heavy metals, pesticides, and other harmful contaminants while preserving beneficial minerals.",
//           icon: <Filter className="text-blue-600" size={24} />
//         },
//         { 
//           title: "Self-Cleaning Technology", 
//           description: "Automatic backwashing system prevents clogging and extends filter life with minimal maintenance required.",
//           icon: <RefreshCw className="text-blue-600" size={24} />
//         },
//         { 
//           title: "Smart Monitoring", 
//           description: "Built-in digital monitoring system tracks water usage, filter status, and provides maintenance alerts through our smartphone app.",
//           icon: <Activity className="text-blue-600" size={24} />
//         },
//         { 
//           title: "High-Flow Design", 
//           description: "Maintains strong water pressure throughout your home even during peak usage times.",
//           icon: <Droplet className="text-blue-600" size={24} />
//         }
//       ]
//     },
//     {
//       id: 'specs',
//       label: 'Specifications',
//       content: [
//         { 
//           title: "Dimensions", 
//           description: "Main Tank: 13\"W × 13\"D × 54\"H, Brine Tank (if applicable): 18\"W × 18\"D × 33\"H",
//           icon: null
//         },
//         { 
//           title: "Flow Rate", 
//           description: "Up to 15 gallons per minute (suitable for homes up to 3,500 sq ft with 3.5 bathrooms)",
//           icon: null
//         },
//         { 
//           title: "Filter Media", 
//           description: "Premium activated carbon, KDF-55, bone char carbon, catalytic carbon, and ion exchange resin depending on your water conditions",
//           icon: null
//         },
//         { 
//           title: "Connection", 
//           description: "1\" or 3/4\" connection compatible with most home plumbing systems",
//           icon: null
//         },
//         { 
//           title: "Electrical", 
//           description: "110V standard outlet for control valve (battery backup included)",
//           icon: null
//         },
//         { 
//           title: "Certification", 
//           description: "NSF/ANSI 42, 53, and 61 certified components",
//           icon: null
//         }
//       ]
//     },
//     {
//       id: 'maintenance',
//       label: 'Maintenance',
//       content: [
//         // { 
//         //   title: "Filter Changes", 
//         //   description: "Primary media lasts 5-7 years; sediment pre-filter replacement every 6-12 months (included in service plan)",
//         //   icon: <Tool className="text-blue-600" size={24} />
//         // },
//         { 
//           title: "Professional Service", 
//           description: "Annual inspection recommended (included in our PureFlow Protection service plans)",
//           icon: <CheckCircle className="text-blue-600" size={24} />
//         },
//         { 
//           title: "Self-Monitoring", 
//           description: "Digital control head displays system status and sends alerts when attention is needed",
//           icon: <Activity className="text-blue-600" size={24} />
//         },
//         { 
//           title: "Warranty Coverage", 
//           description: "10-year warranty on tank, 5-year warranty on valve and electronic components",
//           icon: <Shield className="text-blue-600" size={24} />
//         }
//       ]
//     }
//   ];
  
//   // Process steps
//   const processSteps = [
//     {
//       title: "Free Water Analysis",
//       description: "We test your water to identify specific contaminants and water quality issues in your home.",
//       icon: <HelpCircle size={28} className="text-blue-500" />
//     },
//     // {
//     //   title: "Custom System Design",
//     //   description: "Our experts design a filtration solution tailored to your specific water conditions and household needs.",
//     //   icon: <Tool size={28} className="text-blue-500" />
//     // },
//     {
//       title: "Professional Installation",
//       description: "Our certified technicians install your system with minimal disruption to your home.",
//       icon: <CheckCircle size={28} className="text-blue-500" />
//     },
//     {
//       title: "Ongoing Support",
//       description: "We provide regular maintenance, water testing, and lifetime technical support.",
//       icon: <LifeBuoy size={28} className="text-blue-500" />
//     }
//   ];
  
//   // Comparison table data
//   const comparisonData = [
//     { feature: "Removes chlorine & chloramines", pureflow: true, basic: true, bottled: false },
//     { feature: "Removes heavy metals (lead, mercury)", pureflow: true, basic: "Partial", bottled: "Varies" },
//     { feature: "Removes pesticides & chemicals", pureflow: true, basic: "Partial", bottled: "Varies" },
//     { feature: "Protects all water sources in home", pureflow: true, basic: false, bottled: false },
//     { feature: "Extends appliance lifespan", pureflow: true, basic: "Minimal", bottled: false },
//     { feature: "Improves skin & hair health", pureflow: true, basic: "Minimal", bottled: false },
//     { feature: "Environmentally friendly", pureflow: true, basic: true, bottled: false },
//     { feature: "Long-term cost effectiveness", pureflow: true, basic: "Moderate", bottled: false }
//   ];
  
//   return (
//     <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 overflow-hidden">
//       <NavBar />
      
//       {/* Hero Section */}
//       <div id="hero" className={`relative bg-gradient-to-r from-blue-700 to-blue-500 text-white overflow-hidden transition-all duration-1000 ${getAnimationClass('hero')}`}>
//         {/* Background Elements */}
//         <div className="absolute inset-0 overflow-hidden">
//           <div className="absolute -top-24 -left-24 w-96 h-96 bg-blue-400 rounded-full mix-blend-multiply filter blur-3xl opacity-70"></div>
//           <div className="absolute top-1/2 -right-24 w-80 h-80 bg-blue-300 rounded-full mix-blend-multiply filter blur-3xl opacity-60"></div>
//           <div className="absolute -bottom-32 left-1/3 w-72 h-72 bg-blue-200 rounded-full mix-blend-multiply filter blur-3xl opacity-60"></div>
//         </div>
        
//         {/* Content */}
//         <div className="container mx-auto px-4 py-20 md:py-28 relative z-10">
//           <div className="md:grid md:grid-cols-2 gap-12 items-center">
//             <div className="mb-10 md:mb-0">
//               <div className="inline-block px-4 py-1 bg-blue-800 bg-opacity-50 rounded-full text-sm font-medium mb-6">
//                 Premium Water Filtration Solution
//               </div>
//               <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
//                 PureFlow Whole Home Water Filtration
//               </h1>
//               <p className="text-xl mb-8 text-blue-100">
//                 Experience clean, healthy water from every tap in your home with our advanced whole-house filtration system.
//               </p>
//               <div className="flex flex-wrap gap-4">
//                 <button className="bg-white text-blue-600 px-6 py-3 rounded-full font-medium hover:bg-opacity-90 transition-all duration-300 inline-flex items-center group shadow-lg">
//                   Get a Free Quote <ArrowRight size={18} className="ml-2 transform group-hover:translate-x-1 transition-transform duration-300" />
//                 </button>
//                 <button className="bg-blue-800 bg-opacity-40 hover:bg-opacity-60 text-white px-6 py-3 rounded-full font-medium transition-all duration-300 inline-flex items-center">
//                   Watch Video
//                 </button>
//               </div>
              
//               {/* Trust Badges */}
//               <div className="mt-10 flex items-center space-x-6">
//                 <div className="flex items-center">
//                   <div className="text-yellow-300 flex">
//                     {[...Array(5)].map((_, i) => (
//                       <Star key={i} size={16} fill="currentColor" />
//                     ))}
//                   </div>
//                   <span className="ml-2 text-sm">4.9/5 (300+ reviews)</span>
//                 </div>
//                 <div className="flex items-center">
//                   <Shield size={20} className="mr-1" />
//                   <span className="text-sm">10-Year Warranty</span>
//                 </div>
//               </div>
//             </div>
            
//             {/* Product Image */}
//             <div className="relative">
//               <div className="bg-white bg-opacity-20 backdrop-filter backdrop-blur-sm rounded-3xl p-4">
//                 <div className="bg-white rounded-2xl overflow-hidden shadow-2xl">
//                   <img src="/api/placeholder/600/600" alt="PureFlow Whole Home Water Filtration System" className="w-full h-full object-cover" />
//                 </div>
//               </div>
              
//               {/* Floating Features */}
//               <div className="absolute -left-4 top-1/4 bg-white px-4 py-2 rounded-full shadow-lg flex items-center text-blue-700 text-sm font-medium">
//                 <Shield size={16} className="mr-2" /> NSF Certified
//               </div>
//               <div className="absolute -right-4 bottom-1/4 bg-white px-4 py-2 rounded-full shadow-lg flex items-center text-blue-700 text-sm font-medium">
//                 <Check size={16} className="mr-2" /> 99.9% Contaminant Removal
//               </div>
//             </div>
//           </div>
//         </div>
        
//         {/* Wave Divider */}
//         <div className="absolute bottom-0 left-0 right-0">
//           <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 100" className="w-full text-gray-50 fill-current">
//             <path d="M0,64L80,69.3C160,75,320,85,480,80C640,75,800,53,960,48C1120,43,1280,53,1360,58.7L1440,64L1440,100L1360,100C1280,100,1120,100,960,100C800,100,640,100,480,100C320,100,160,100,80,100L0,100Z"></path>
//           </svg>
//         </div>
//       </div>
      
//       {/* Benefits Section */}
//       <div id="benefits" className={`container mx-auto px-4 py-20 transition-all duration-1000 delay-200 ${getAnimationClass('benefits')}`}>
//         <div className="text-center max-w-3xl mx-auto mb-16">
//           <h2 className="text-3xl md:text-4xl font-bold mb-6 text-blue-700">
//             Transform Your Home's Water Quality
//           </h2>
//           <p className="text-lg text-gray-600">
//             Our whole-home filtration system provides clean, healthy water from every tap in your home, protecting your family's health and your home's plumbing and appliances.
//           </p>
//         </div>
        
//         <div className="grid md:grid-cols-3 gap-8">
//           <div className="bg-white rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden group">
//             <div className="h-48 bg-blue-100 flex items-center justify-center relative overflow-hidden">
//               <div className="text-blue-500 transform group-hover:scale-110 transition-transform duration-500">
//                 <svg width="120" height="120" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                   <path d="M12 3C12 3 7 6 7 12C7 18 12 21 12 21C12 21 17 18 17 12C17 6 12 3 12 3Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="rgba(59, 130, 246, 0.2)" />
//                   <path d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//                 </svg>
//               </div>
//               <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-blue-600 to-transparent h-1/3 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
//             </div>
//             <div className="p-6">
//               <h3 className="text-xl font-bold text-blue-700 mb-3">Healthier Water</h3>
//               <p className="text-gray-600">
//                 Removes chlorine, lead, pesticides, and hundreds of other contaminants that impact your health. Enjoy peace of mind knowing your family is protected.
//               </p>
//             </div>
//           </div>
          
//           <div className="bg-white rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden group">
//             <div className="h-48 bg-blue-100 flex items-center justify-center relative overflow-hidden">
//               <div className="text-blue-500 transform group-hover:scale-110 transition-transform duration-500">
//                 <svg width="120" height="120" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                   <path d="M4 19.5C4 18.837 4.26339 18.2011 4.73223 17.7322C5.20107 17.2634 5.83696 17 6.5 17H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//                   <path d="M6.5 2H20V22H6.5C5.83696 22 5.20107 21.7366 4.73223 21.2678C4.26339 20.7989 4 20.163 4 19.5V4.5C4 3.83696 4.26339 3.20107 4.73223 2.73223C5.20107 2.26339 5.83696 2 6.5 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="rgba(59, 130, 246, 0.2)" />
//                 </svg>
//               </div>
//               <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-blue-600 to-transparent h-1/3 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
//             </div>
//             <div className="p-6">
//               <h3 className="text-xl font-bold text-blue-700 mb-3">Save Money</h3>
//               <p className="text-gray-600">
//                 Extend the life of appliances, plumbing fixtures, and water heaters by preventing scale buildup. Eliminate the need for bottled water.
//               </p>
//             </div>
//           </div>
          
//           <div className="bg-white rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden group">
//             <div className="h-48 bg-blue-100 flex items-center justify-center relative overflow-hidden">
//               <div className="text-blue-500 transform group-hover:scale-110 transition-transform duration-500">
//                 <svg width="120" height="120" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                   <path d="M20.84 4.61C20.3292 4.099 19.7228 3.69364 19.0554 3.41708C18.3879 3.14052 17.6725 2.99817 16.95 2.99817C16.2275 2.99817 15.5121 3.14052 14.8446 3.41708C14.1772 3.69364 13.5708 4.099 13.06 4.61L12 5.67L10.94 4.61C9.9083 3.57831 8.50903 2.99871 7.05 2.99871C5.59096 2.99871 4.19169 3.57831 3.16 4.61C2.1283 5.64169 1.54871 7.04097 1.54871 8.5C1.54871 9.95903 2.1283 11.3583 3.16 12.39L4.22 13.45L12 21.23L19.78 13.45L20.84 12.39C21.351 11.8792 21.7563 11.2728 22.0329 10.6054C22.3095 9.93789 22.4518 9.22248 22.4518 8.5C22.4518 7.77752 22.3095 7.0621 22.0329 6.39464C21.7563 5.72718 21.351 5.12075 20.84 4.61Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="rgba(59, 130, 246, 0.2)" />
//                 </svg>
//               </div>
//               <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-blue-600 to-transparent h-1/3 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
//             </div>
//             <div className="p-6">
//               <h3 className="text-xl font-bold text-blue-700 mb-3">Better Living</h3>
//               <p className="text-gray-600">
//                 Enjoy softer skin and hair, spot-free dishes, brighter laundry, and better-tasting water for cooking, coffee, and drinking.
//               </p>
//             </div>
//           </div>
//         </div>
        
//         {/* Additional Benefits */}
//         <div className="mt-16 grid md:grid-cols-2 gap-8">
//           <div className="bg-white rounded-xl shadow-md p-8">
//             <h3 className="text-2xl font-bold text-blue-700 mb-6">For Your Family</h3>
//             <div className="space-y-4">
//               <div className="flex items-start">
//                 <div className="mt-1 bg-blue-100 rounded-full p-1 mr-4 text-blue-600">
//                   <Check size={18} />
//                 </div>
//                 <div>
//                   <h4 className="font-semibold text-gray-800">Healthier Drinking Water</h4>
//                   <p className="text-gray-600 text-sm">Remove chlorine, lead, pesticides, and hundreds of other contaminants</p>
//                 </div>
//               </div>
//               <div className="flex items-start">
//                 <div className="mt-1 bg-blue-100 rounded-full p-1 mr-4 text-blue-600">
//                   <Check size={18} />
//                 </div>
//                 <div>
//                   <h4 className="font-semibold text-gray-800">Softer Skin & Hair</h4>
//                   <p className="text-gray-600 text-sm">Reduce dry skin, eczema flare-ups, and brittle hair from harsh chemicals</p>
//                 </div>
//               </div>
//               <div className="flex items-start">
//                 <div className="mt-1 bg-blue-100 rounded-full p-1 mr-4 text-blue-600">
//                   <Check size={18} />
//                 </div>
//                 <div>
//                   <h4 className="font-semibold text-gray-800">Cleaner Laundry</h4>
//                   <p className="text-gray-600 text-sm">Clothes feel softer and look brighter with filtered water</p>
//                 </div>
//               </div>
//               <div className="flex items-start">
//                 <div className="mt-1 bg-blue-100 rounded-full p-1 mr-4 text-blue-600">
//                   <Check size={18} />
//                 </div>
//                 <div>
//                   <h4 className="font-semibold text-gray-800">Better Tasting Food</h4>
//                   <p className="text-gray-600 text-sm">Improve the flavor of coffee, tea, and home-cooked meals</p>
//                 </div>
//               </div>
//             </div>
//           </div>
          
//           <div className="bg-white rounded-xl shadow-md p-8">
//             <h3 className="text-2xl font-bold text-blue-700 mb-6">For Your Home</h3>
//             <div className="space-y-4">
//               <div className="flex items-start">
//                 <div className="mt-1 bg-blue-100 rounded-full p-1 mr-4 text-blue-600">
//                   <Check size={18} />
//                 </div>
//                 <div>
//                   <h4 className="font-semibold text-gray-800">Extended Appliance Life</h4>
//                   <p className="text-gray-600 text-sm">Protect water heaters, washing machines, and dishwashers from scale damage</p>
//                 </div>
//               </div>
//               <div className="flex items-start">
//                 <div className="mt-1 bg-blue-100 rounded-full p-1 mr-4 text-blue-600">
//                   <Check size={18} />
//                 </div>
//                 <div>
//                   <h4 className="font-semibold text-gray-800">Fewer Plumbing Issues</h4>
//                   <p className="text-gray-600 text-sm">Prevent scale buildup in pipes and fixtures that can lead to costly repairs</p>
//                 </div>
//               </div>
//               <div className="flex items-start">
//                 <div className="mt-1 bg-blue-100 rounded-full p-1 mr-4 text-blue-600">
//                   <Check size={18} />
//                 </div>
//                 <div>
//                   <h4 className="font-semibold text-gray-800">Spot-Free Dishes & Fixtures</h4>
//                   <p className="text-gray-600 text-sm">Eliminate water spots on glassware and bathroom fixtures</p>
//                 </div>
//               </div>
//               <div className="flex items-start">
//                 <div className="mt-1 bg-blue-100 rounded-full p-1 mr-4 text-blue-600">
//                   <Check size={18} />
//                 </div>
//                 <div>
//                   <h4 className="font-semibold text-gray-800">Less Cleaning</h4>
//                   <p className="text-gray-600 text-sm">Reduce soap scum and mineral deposits that create extra cleaning work</p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       </div>
// )}
//       {/* Product Features Section with Tabs */}
//       {/* <div id="features" className={`bg-white py-20 transition-all duration-1000 delay-300 ${getAnimationClass('features')}`}>
//         <div className="container mx-auto px-4">
//           <div className="text-center mb-12">
//             <h2 className="text-3xl md:text-4xl font-bold mb-4 text-blue-700">PureFlow Max System</h2>
//             <p className="text-gray-600 max-w-2xl mx-auto text-lg">
//               Advanced filtration technology designed for modern homes
//             </p>
//           </div> */}
          
//           {/* Product Showcase */}
//           {/* <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
//             <div className="relative">
//               <div className="bg-blue-50 rounded-3xl p-6 md:p-10 relative overflow-hidden">
//                 <div className="absolute top-0 right-0 w-64 h-64 bg-blue-100 rounded-full -mr-32 -mt-32"></div>
//                 <div className="absolute bottom-0 left-0 w-40 h-40 bg-blue-100 rounded-full -ml-20 -mb-20"></div>
//                 <div className="relative z-10">
//                   <img src="/api/placeholder/500/700" alt="PureFlow Max System" className="mx-auto max-h-96 object-contain" />
//                 </div>
//               </div>
              
//               {/* Feature Badges */}
//               {/* <div className="absolute top-10 -left-4 bg-blue-600 text-white px-4 py-2 rounded-lg shadow-lg text-sm font-medium">
//                 5-Stage Filtration
//               </div>
//               <div className="absolute top-1/3 -right-4 bg-blue-600 text-white px-4 py-2 rounded-lg shadow-lg text-sm font-medium"></div> */} 




import { useState, useEffect } from 'react';
import { 
  Droplet, Shield, Check, ArrowRight, Star, 
  CheckCircle, HelpCircle, Tool, Filter, Activity, 
  RefreshCw, LifeBuoy, ThumbsUp, ChevronDown, ChevronRight 
} from 'lucide-react';
import NavBar from '../components/Navbar';
import Footer from '../components/Footer';

export default function WholeHomeWaterFiltration() {
  const [activeTab, setActiveTab] = useState('features');
  const [isVisible, setIsVisible] = useState({
    hero: false,
    benefits: false,
    features: false,
    process: false,
    comparison: false,
    faq: false,
    testimonials: false,
    cta: false
  });
  
  const [activeFaq, setActiveFaq] = useState(null);
  const [activeTestimonial, setActiveTestimonial] = useState(0);
  
  // Intersection Observer for animations
  useEffect(() => {
    const observerOptions = {
      threshold: 0.2,
      rootMargin: '0px 0px -100px 0px'
    };
    
    const observerCallback = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsVisible(prev => ({ ...prev, [entry.target.id]: true }));
        }
      });
    };
    
    const observer = new IntersectionObserver(observerCallback, observerOptions);
    
    const sections = ['hero', 'benefits', 'features', 'process', 'comparison', 'faq', 'testimonials', 'cta'];
    sections.forEach(section => {
      const element = document.getElementById(section);
      if (element) observer.observe(element);
    });
    
    return () => {
      sections.forEach(section => {
        const element = document.getElementById(section);
        if (element) observer.unobserve(element);
      });
    };
  }, []);
  
  // Animation classes
  const getAnimationClass = (section) => {
    return isVisible[section] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10';
  };
  
  // FAQ data
  const faqItems = [
    {
      question: "How long does a whole home water filtration system last?",
      answer: "Our systems are built to last 15-20 years with proper maintenance. The main filtration tank typically lasts the full system lifetime, while filter media should be replaced every 5-7 years depending on your water conditions."
    },
    {
      question: "Does the system require professional installation?",
      answer: "While professional installation is recommended, our systems are designed for straightforward installation. Our certified technicians can complete most installations in 2-3 hours with minimal disruption."
    },
    {
      question: "Will a whole home system affect my water pressure?",
      answer: "Our systems are engineered to maintain your home's water pressure with minimal pressure drop (typically less than 5 PSI), even during peak water usage times."
    },
    {
      question: "How much maintenance is required?",
      answer: "Systems include automatic self-cleaning cycles, and most homeowners only need professional servicing once every 1-2 years. We provide maintenance reminders and service plans."
    }
  ];
  
  // Testimonials data
  const testimonials = [
    {
      text: "The difference in our water quality is remarkable. No more dry skin, spotty dishes, or mineral buildup on our fixtures. The system has transformed our water and was worth every penny.",
      author: "Michael & Sarah Johnson",
      location: "Homeowners since 2023",
      rating: 5
    },
    {
      text: "As someone with sensitive skin and allergies, I've noticed a huge improvement since installation. The shower water feels softer, and I no longer have the itchy feeling after bathing.",
      author: "Jennifer Torres",
      location: "Homeowner since 2022",
      rating: 5
    }
  ];
  
  // Features tabs
  const featureTabs = [
    {
      id: 'features',
      label: 'Key Features',
      content: [
        { 
          title: "Multi-Stage Filtration", 
          description: "Our 3-stage filtration process removes sediment, chlorine, heavy metals, and other harmful contaminants while preserving beneficial minerals.",
          icon: <Filter className="text-blue-600" size={24} />
        },
        { 
          title: "Self-Cleaning Technology", 
          description: "Automatic backwashing system prevents clogging and extends filter life with minimal maintenance required.",
          icon: <RefreshCw className="text-blue-600" size={24} />
        },
        { 
          title: "Smart Monitoring", 
          description: "Built-in digital monitoring system tracks water usage, filter status, and provides maintenance alerts.",
          icon: <Activity className="text-blue-600" size={24} />
        }
      ]
    }
  ];
  
  // Process steps
  const processSteps = [
    {
      title: "Know what's in your water",
      description: "Experience the difference with soft filtered water in your shower, fresher laundry, and chemical-free drinking water.",
      icon: <HelpCircle size={28} className="text-blue-500" />
    },
    // {
    //   title: "Make the move",
    //   description: "With affordable financing options starting from just $20/week.",
    //   icon: <Tool size={28} className="text-blue-500" />
    // },
    {
      title: "Enjoy pure water",
      description: "We handle installation and you enjoy the benefits of clean water throughout your home.",
      icon: <CheckCircle size={28} className="text-blue-500" />
    }
  ];
  
  return (
    <div className="min-h-screen bg-white overflow-hidden">
      <NavBar />
      
      {/* Hero Section */}
      <div id="hero" className={`relative bg-gradient-to-br from-blue-900 to-blue-600 text-white overflow-hidden transition-all duration-1000 ${getAnimationClass('hero')}`}>
        <div className="absolute inset-0 opacity-20">
        </div>
        
        <div className="container mx-auto px-4 py-20 md:py-28 relative z-10">
          <div className="md:grid md:grid-cols-2 gap-12 items-center">
            <div className="mb-10 md:mb-0">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
                How does a whole home filter work?
              </h1>
              <p className="text-xl mb-8 text-blue-100">
                A whole home water filter system purifies the water entering your home by removing impurities through multiple stages of filtration. It ensures clean, safe water for every faucet and appliance.
              </p>
              
              <div className="mt-12">
                <h2 className="text-2xl font-semibold mb-4">Our Difference</h2>
                <p className="text-lg mb-6">
                  What sets us apart is our use of cutting-edge Avagorn filter technology, providing unparalleled filtration and purification.
                </p>
                <button className="bg-white text-blue-600 px-8 py-4 rounded-full font-medium hover:bg-opacity-90 transition-all duration-300 inline-flex items-center group shadow-lg text-lg">
                <a href='/contact'>  Book Your Free Water Test</a>
                </button>
              </div>
            </div>
            
            <div className="relative">
              <div className="bg-white/10 backdrop-blur-md rounded-3xl p-1 overflow-hidden border border-white/20">
                <div className="bg-gradient-to-br from-blue-500 to-blue-700 rounded-2xl p-8">
                  <div className="flex flex-col space-y-6">
                    <div className="flex items-start space-x-4">
                      <div className="bg-white/20 p-3 rounded-full">
                        <Droplet size={24} className="text-white" />
                      </div>
                      <div>
                        <h3 className="text-xl font-semibold">Pipeline Water</h3>
                        <p className="text-blue-100">3-stage filtration system</p>
                      </div>
                    </div>
                    <div className="h-1 bg-white/20 rounded-full"></div>
                    <div className="text-center py-4">
                      <span className="text-2xl font-bold">CLEAN WATER</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Avagorn Difference Section */}
      {/* <div id="benefits" className={`py-20 transition-all duration-1000 delay-200 ${getAnimationClass('benefits')}`}>
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-blue-700">
              Why Avagorn Makes All The Difference...
            </h2>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            <div className="bg-gradient-to-b from-blue-50 to-white rounded-2xl p-8 border border-blue-100 relative overflow-hidden group">
              <div className="absolute -right-10 -top-10 w-40 h-40 bg-blue-200 rounded-full opacity-20 group-hover:opacity-30 transition-opacity duration-500"></div>
              <div className="relative z-10">
                <div className="bg-blue-100 p-3 rounded-full w-14 h-14 flex items-center justify-center mb-6">
                  <Filter size={24} className="text-blue-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Advanced Filtration</h3>
                <p className="text-gray-600">
                  Avagorn filters employ state-of-the-art technology to effectively remove contaminants, including sediments, chemicals, and microorganisms.
                </p>
              </div>
            </div>
            
            <div className="bg-gradient-to-b from-blue-50 to-white rounded-2xl p-8 border border-blue-100 relative overflow-hidden group">
              <div className="absolute -left-10 -bottom-10 w-40 h-40 bg-blue-200 rounded-full opacity-20 group-hover:opacity-30 transition-opacity duration-500"></div>
              <div className="relative z-10">
                <div className="bg-blue-100 p-3 rounded-full w-14 h-14 flex items-center justify-center mb-6">
                  <Shield size={24} className="text-blue-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Longevity and Durability</h3>
                <p className="text-gray-600">
                  Avagorn filters are built to last, reducing the need for frequent replacements and maintenance. This provides long-term cost savings.
                </p>
              </div>
            </div>
            
            <div className="bg-gradient-to-b from-blue-50 to-white rounded-2xl p-8 border border-blue-100 relative overflow-hidden group">
              <div className="absolute -right-10 -bottom-10 w-40 h-40 bg-blue-200 rounded-full opacity-20 group-hover:opacity-30 transition-opacity duration-500"></div>
              <div className="relative z-10">
                <div className="bg-blue-100 p-3 rounded-full w-14 h-14 flex items-center justify-center mb-6">
                  <CheckCircle size={24} className="text-blue-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Health and Safety</h3>
                <p className="text-gray-600">
                  With Avagorn's robust filtration capabilities, you can enjoy peace of mind knowing that your water is free from harmful impurities.
                </p>
              </div>
            </div>
          </div>
          
          <div className="mt-16 text-center">
            <div className="inline-flex space-x-6">
              <button className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-full font-medium transition-all duration-300 inline-flex items-center shadow-lg">
                Download The Avagorn Brochure
              </button>
              <button className="bg-white hover:bg-gray-50 text-blue-600 px-8 py-3 rounded-full font-medium transition-all duration-300 inline-flex items-center border border-blue-200 shadow">
                View The Avagorn Filter Test Results
              </button>
            </div>
          </div>
        </div>
      </div> */}

      {/* Simple & Affordable Section */}
      <div id="process" className={`bg-gradient-to-br from-blue-50 to-white py-20 transition-all duration-1000 delay-300 ${getAnimationClass('process')}`}>
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-blue-700">Simple & Affordable</h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Installed from just $20 a week with our flexible financing options
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-10 max-w-6xl mx-auto">
            
            {processSteps.map((step, index) => (
              <div key={index} className="relative group">
                <div className="absolute -inset-1 bg-gradient-to-r from-blue-400 to-blue-600 rounded-2xl opacity-0 group-hover:opacity-20 blur transition-all duration-500"></div>
                <div className="relative bg-white rounded-2xl p-8 h-full border border-gray-100 shadow-sm hover:shadow-md transition-shadow duration-300">
                  <div className="flex items-center mb-6">
                    <div className="bg-blue-100 p-2 rounded-full mr-4 text-blue-600">
                      {step.icon}
                    </div>
                    <span className="text-2xl font-bold text-blue-600">Step {index + 1}</span>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{step.title}</h3>
                  <p className="text-gray-600">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
          
          <div className="mt-16 bg-white rounded-2xl p-8 max-w-4xl mx-auto border border-gray-100 shadow-sm">
            <div className="text-center">
              <p className="text-lg text-gray-700 mb-6">
                Once you feel the soft filtered water in the shower, notice the fresher, cleaner smell in your laundry and of course enjoy the taste of chemical free drinking water you'll be kicking yourself you didn't get a whole home water filter sooner!
              </p>
              <p className="text-xl font-semibold text-blue-600">
                With finance available you can even get a system installed from as little as $20 a week.
              </p>
            </div>
          </div>
        </div>
      </div>
      
      {/* FAQ Section */}
      <div id="faq" className={`py-20 transition-all duration-1000 delay-500 ${getAnimationClass('faq')}`}>
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-blue-700">Frequently Asked Questions</h2>
          </div>
          
          <div className="space-y-4">
            {faqItems.map((item, index) => (
              <div key={index} className="border-b border-gray-200 pb-4">
                <button
                  className="flex justify-between items-center w-full text-left py-4 focus:outline-none"
                  onClick={() => setActiveFaq(activeFaq === index ? null : index)}
                >
                  <h3 className="text-lg font-medium text-gray-900">{item.question}</h3>
                  {activeFaq === index ? (
                    <ChevronDown className="text-blue-600 transform rotate-180 transition-transform duration-300" />
                  ) : (
                    <ChevronRight className="text-blue-600 transition-transform duration-300" />
                  )}
                </button>
                {activeFaq === index && (
                  <div className="mt-2 text-gray-600 pl-2">
                    <p>{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
      
      {/* Testimonials Section */}
      <div id="testimonials" className={`bg-blue-50 py-20 transition-all duration-1000 delay-700 ${getAnimationClass('testimonials')}`}>
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-blue-700">What Our Customers Say</h2>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-md transition-shadow duration-300">
                <div className="flex mb-4">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} size={20} className="text-yellow-400 fill-current" />
                  ))}
                </div>
                <p className="text-gray-700 italic mb-6">"{testimonial.text}"</p>
                <div className="flex items-center">
                  <div className="bg-blue-100 rounded-full w-12 h-12 flex items-center justify-center text-blue-600 font-bold mr-4">
                    {testimonial.author.charAt(0)}
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">{testimonial.author}</h4>
                    <p className="text-sm text-gray-500">{testimonial.location}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      
      {/* CTA Section */}
      <div id="cta" className={`bg-gradient-to-r from-blue-600 to-blue-800 text-white py-20 transition-all duration-1000 delay-1000 ${getAnimationClass('cta')}`}>
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Ready for Cleaner, Healthier Water?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto text-blue-100">
            Experience the Avagorn difference in your home today. Schedule your free water test and consultation.
          </p>
          <button className="bg-white text-blue-600 hover:bg-blue-50 px-8 py-4 rounded-full font-medium transition-all duration-300 inline-flex items-center shadow-lg text-lg mx-2">
          <a href='/contact'>  Book Your Free Water Test </a>
          </button>
          {/* <button className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-blue-600 px-8 py-4 rounded-full font-medium transition-all duration-300 inline-flex items-center text-lg mx-2">
            Call Now: (555) 123-4567
          </button> */}
        </div>
      </div>
      
      <Footer />
    </div>
  );
}